export const useAppVersion = () => import.meta.env.VITE_VERSION || 'pre-release';
